<template lang="pug">
  v-app#app.white
    .logged(v-if="$route.path !== '/noRole' && logged && IHaveRole('touristic_maps_admin')")
      rc-error-handler
      v-content(v-if="$route.query.context !== 'choice'")
        banner
        .white.px-4.pb-3(v-if="logged")
          v-tabs.main-tabs.elevation-2.mb-3.white--text(
            slider-color="white"
            color="primary"
            v-if="logged"
            dark
          )
            v-tab(to="/maps") Mes cartes
            v-tab(to="/permissions") Diffusion
            v-tab(to="/consumption") Consommation
          router-view
      v-content(v-else)
        router-view
    v-layout.noRole(v-else-if="$route.path === '/noRole' && logged")
      v-flex.xs7.noRole-content.white
        v-layout.justify-center
          v-flex.xs8
            v-layout.column.text-xs-center
              img.logo.mb-3(height="80px" src="./assets/logo-tmaps.png")
              .title.primary--text.font-weight-regular.mb-5 Vous ne disposez pas des droits nécessaires pour accéder à ce service.
              span.title.primary--text.font-weight-regular.mb-5 Vous êtes actuellement connecté avec le compte
                span.title.primary--text.font-weight-bold  {{ logged }}
              v-layout.noRole-btns.justify-center.mb-5
                v-btn(color="primary" @click="goToDetails") En savoir plus sur TouristicMaps
                v-btn(@click="switchAccount") Me connecter à TouristicMaps avec un autre compte
</template>

<script>
import Banner from '@/views/Banner.vue';
import RcBreadcrumb from '@/components/RcBreadcrumb.vue';
import RcErrorHandler from '@/components/RcErrorHandler.vue';

export default {
  components: {
    Banner,
    RcBreadcrumb,
    RcErrorHandler,
  },
  methods: {
    goToDetails() {
      const win = window.open('https://www.touristicmaps.com', '_blank');
      win.focus();
    },
    switchAccount() {
      const redirectUri = window.location.origin;
      window.location.href = `${window.location.origin}/api/v2/tmaps/logout?redirect_uri=${redirectUri}`;
    },
    IHaveRole(requiredRole) {
      const { roles } = this.$store.state.user.logged;
      return roles.filter(role => role === requiredRole).length > 0;
    },
  },
  computed: {
    logged() {
      return this.$store.state.user.logged.login != null;
    },
  },
};
</script>

<style lang="scss">
  .v-overlay {
    z-index: 1001!important;
  }
  .v-dialog__content {
    z-index: 1002!important;
  }

  .v-input--slider .v-label {
    color: #9e9e9e!important;
  }
  .line-through {
    text-decoration: line-through;
  }
  .noRole {
    height: 100vh;
    width: 100vw;
    background-image: url('./assets/background-tmaps.png');
    background-size: cover;
    background-position: center center;
    display: flex;
    justify-content: center;
    align-items: center;
    .noRole-content {
      min-height: 45vh;
      .logo {
        width: auto;
        max-width: 100%;
        height: auto;
      }
      .noRole-btns {
        .v-btn__content {
          text-transform: none;
        }
      }
    }
  }
  .underline {
    text-decoration: underline;
  }
  .main-tabs {
    .v-tabs__div {
      font-size: 18px;
      padding: 0 1em 0 1em;
    }
  }
  #edit-preview-map {
    width: 500px;
    height: 500px;
  }
  .click {
    cursor: pointer;
  }
  .max-height {
    height: 100%;
  }
  .scroll-y-overflow {
    overflow-y: auto;
  }
  .content-card {
    height: calc(100vh - 220px);
  }
  .content-card-choice {
    min-height: 100vh;
  }
  @-moz-keyframes spin {
    from { -moz-transform: rotate(0deg); }
    to { -moz-transform: rotate(360deg); }
  }
  @-webkit-keyframes spin {
    from { -webkit-transform: rotate(0deg); }
    to { -webkit-transform: rotate(360deg); }
  }
  @keyframes spin {
    from {transform:rotate(0deg);}
    to {transform:rotate(360deg);}
  }
  .load-wrapper.load-content.choice-load {
    .isPending:after {
      border-top: 6px solid #50C054!important;
    }
    .isPending.small:after {
      border-top: 3px solid #50C054!important;
    }
  }
  .load-wrapper.load-content {
    position: relative;
    > *:not(.isPending) {
      opacity: 0;
    }
    pointer-events: none;
    .isPending {
      pointer-events: none;
    }
    .isPending > * {
      opacity: 0;
    }
    .isPending:after {
      content: '';
      position: absolute;
      top: var(--topOffset);
      left: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      -webkit-animation-name: spin;
      -moz-animation-name: spin;
      animation-name: spin;
      -webkit-animation-duration: 1s;
      -moz-animation-duration: 1s;
      animation-duration: 1s;
      -webkit-animation-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
      -moz-animation-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
      animation-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
      -webkit-animation-iteration-count: infinite;
      -moz-animation-iteration-count: infinite;
      animation-iteration-count: infinite;
      z-index: 50;
    }
    .isPending.white:after {
      border-color: rgba(255, 255, 255, 0.2) !important;
      border-top-color: rgba(255, 255, 255, 0.4) !important;
    }
    .isPending:after {
      margin-top: -30px;
      margin-left: -30px;
      border: 6px solid rgba(0, 0, 0, 0.2);
      border-top: 6px solid #f25715;
      width: 60px;
      height: 60px;
      -moz-box-shadow: 0 0 100px rgba(255, 255, 255, 0.12);
      box-shadow: 0 0 100px rgba(255, 255, 255, 0.12);
    }
    .isPending.small:after {
      margin-top: -15px;
      margin-left: -15px;
      border: 3px solid rgba(0, 0, 0, 0.2);
      border-top: 3px solid #f25715;
      width: 30px;
      height: 30px;
    }
  }
</style>
